import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1496153c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/css/main.sass?vue&type=style&index=0&prod&lang=sass&external"
import style1 from "@/assets/font-awesome/css/all.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports